// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ArrowUpRightIcon = props => <Icon {...props} dangerouslySetIcon={'<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.296 5.704c0 .56.45 1 1 1h5.59l-10.89 10.89a.996.996 0 101.41 1.41l10.89-10.89v5.59c0 .55.45 1 1 1s1-.45 1-1v-8c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1z" fill="#currentColor"/></svg>'} />;

ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';

export default ArrowUpRightIcon;
